<template>
  <div class="header_wrap">
    <div class="top_nav_box"></div>
    <header class="header">
      <div class="container">
        <h1>
          <a href="" class="router-link-active">
            <img alt="logo" class="nav-logo" src="../assets/img/logo.png" />
          </a>
        </h1>
        <div class="lang_area">
          <a
            :class="['lang_ch', lang == 'cn' ? 'current' : '']"
            lang="zh-cn"
            @click.prevent="changeLang(1)"
            >{{ $t("top.Cnlang") }}</a
          >
          <i class="s_line">|</i>
          <a
            :class="['lang_ch', lang == 'cn' ? '' : 'current']"
            lang="en-us"
            @click.prevent="changeLang(2)"
            >{{ $t("top.Enlang") }}</a
          >
        </div>
        <div class="menu_con right">
          <ul class="nav_list flex-display">
            <li class="nav_item" :class="class_active">
              <router-link to="/Home">{{ $t("top.Home") }}</router-link>
            </li>
            <el-popover placement="bottom" trigger="hover">
              <dl>
                <dd>
                  <router-link to="/About?page=1">{{
                    $t("top.Company_Profile")
                  }}</router-link>
                </dd>
                <dd>
                  <router-link to="/About?page=2">{{
                    $t("top.Corporate_philosophy")
                  }}</router-link>
                </dd>
                <dd>
                  <router-link to="/About?page=3">{{
                    $t("top.Corporate_Honors")
                  }}</router-link>
                </dd>
                <dd>
                  <router-link to="/About?page=4">{{
                    $t("top.Company_Scenarios")
                  }}</router-link>
                </dd>
              </dl>
              <li class="nav_item" slot="reference">
                <router-link to="/About">{{ $t("top.About") }}</router-link>
              </li>
            </el-popover>
            <el-popover placement="bottom" trigger="hover">
              <dl>
                <dd
                  v-for="(item, index) in categoriesList"
                  :key="'categoriesList' + index"
                >
                  <router-link :to="`/Products?id=${item.id}`">{{
                    item.title
                  }}</router-link>
                </dd>
              </dl>
              <li class="nav_item" slot="reference">
                <router-link to="/Products">{{
                  $t("top.Products")
                }}</router-link>
              </li>
            </el-popover>
            <li class="nav_item">
              <router-link to="/News">{{ $t("top.News") }}</router-link>
            </li>
            <li class="nav_item">
              <router-link to="/Service">{{ $t("top.Service") }}</router-link>
            </li>
            <li class="nav_item">
              <router-link to="/Contact">{{ $t("top.Contact") }}</router-link>
            </li>
          </ul>
          <div style="clear: both"></div>
        </div>
        <!-- <el-menu
          :default-active="index_s"
          class="nav"
          mode="horizontal"
          router
          active-text-color="#3c427c"
        >
          <el-menu-item index="/Home"  @click="saveNavState('/Home')">{{ $t("top.Home") }} </el-menu-item>
          <el-submenu index="/About" popper-class="popper_menu">
            <template slot="title">{{ $t("top.About") }}</template>
            <el-menu-item index="/About?page=1" @click="saveNavState('/About?page=1')">{{
              $t("top.Company_Profile")
            }}</el-menu-item>
            <el-menu-item index="/About?page=2" @click="saveNavState('/About?page=2')">{{
              $t("top.Corporate_philosophy")
            }}</el-menu-item>
            <el-menu-item index="/About?page=3" @click="saveNavState('/About?page=3')">{{
              $t("top.Corporate_Honors")
            }}</el-menu-item>
            <el-menu-item index="/About?page=4" @click="saveNavState('/About?page=4')">{{
              $t("top.Company_Scenarios")
            }}</el-menu-item>
          </el-submenu>
          <el-menu-item index="/Products" @click="saveNavState('/Products')"
            >{{ $t("top.Products") }}
          </el-menu-item>
          <el-menu-item index="/News" @click="saveNavState('/News')">{{ $t("top.News") }} </el-menu-item>
          <el-menu-item index="/Contact" @click="saveNavState('/Contact')">{{ $t("top.Contact") }} </el-menu-item>
        </el-menu> -->
      </div>
    </header>
  </div>
</template>

<script>
export default {
  // 监听,当路由发生变化的时候执行
  watch: {
    $route (to, from) {
      console.log(to)
      if (to.name === 'Home' || to.name === 'home') {
        this.class_active = 'active'
      } else {
        this.class_active = ''
      }
    }
  },
  name: 'Top',
  data () {
    return {
      class_active: '',
      lang: localStorage.lang || 'cn', // lang 1中文  2英文
      categoriesList: [],
      title: ''
    }
  },
  created () {
    if (this.lang === 'cn') {
      document.title = '温岭格朗智能科技有限公司'
    } else {
      document.title = 'WENLING GLANG INTELLIGENT TECHNOLOGY CO., LTD'
    }

    this.getCategoriesList()
    if (this.$route.name === 'Home' || this.$route.name === 'home') {
      this.class_active = 'active'
    } else {
      this.class_active = ''
    }
  },
  methods: {
    getCategoriesList () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_product_categories'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log('getCategoriesList')
        if (res.meta.status === 200) {
          that.categoriesList = res.data
        }
      })
    },
    changeLang (index) {
      console.log('changeLang')
      if (index === 2 && this.lang === 'cn') {
        this.lang = 'en'
        this.$i18n.locale = 'en'
        localStorage.setItem('lang', 'en')
      } else if (index === 1 && this.lang === 'en') {
        this.lang = 'cn'
        this.$i18n.locale = 'cn'
        localStorage.setItem('lang', 'cn')
      }
      location.reload()
    },
    saveNavState (activePath) {
      console.log(activePath)
      this.index_s = activePath
    }
  }
}
</script>

<style scoped>
.header_wrap {
  height: 80px;
}
.top_nav_box {
  height: 80px;
}
.header {
  height: 80px;
  background-color: #fff;
  color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  line-height: 80px;
  z-index: 100;
  position: fixed;
  border-bottom: 1px solid #dcdfe6;
}

.header .container {
  height: 100%;
  box-sizing: border-box;
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  /* border-bottom:1px solid #dcdfe6; */
}

.header .nav-logo {
  vertical-align: sub;
  height: 38px;
}
.header h1 {
  margin: 0;
  float: left;
  font-size: 32px;
  font-weight: 400;
}

.header h1 a {
  color: #333;
  text-decoration: none;
  display: block;
}

.header .menu_con {
  float: right;
  height: 100%;
  line-height: 80px;
  background: transparent;
  padding: 0;
  margin: 0;
}

.header .menu_con:after,
.header .menu_con:before {
  display: table;
  content: "";
}

.header .menu_con:after {
  clear: both;
}

.header .nav_item {
  padding: 0;
  float: left;
  list-style: none;
  position: relative;
  cursor: pointer;
  margin: 0 22px;
  font-size: 16px;
}
.header .nav_item a {
  color: #666666;
  height: 80px;
  opacity: 0.7;
  display: inline-block;
}
.header .nav_item:hover a {
  color: #3c427c;
  opacity: 1;
}
.header .nav_item.active a {
  color: #3c427c;
  opacity: 1;
}
.header .menu_con dl {
  display: none;
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translate(-50%, 0);
  padding-top: 10px;
}
.lang_area {
  right: 0px;
  line-height: 80px;
  color: #000;
  float: right;
  margin-left: 100px;
}
.lang_area a {
  display: inline-block;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  opacity: 0.7;
  cursor: pointer;
}
.lang_area a:hover {
  opacity: 0.95;
}
.lang_area a.current {
  opacity: 1;
}
.lang_area .s_line {
  display: inline-block;
  font-size: 12px;
  margin: 0px 3px;
  position: relative;
  top: -2px;
  opacity: 0.7;
}
.lang_area a,
.head_white .lang_area a {
  color: #2b2e2e;
}
.lang_area .s_line,
.head_white .lang_area .s_line {
  color: #2b2e2e;
}
</style>
